<template>
  <li class="panel-block flex-space-between">
    <section>
      <router-link :to="'/videos/' + id">{{ title }}</router-link>
      <p v-if="cycleTitle"><small>in</small> {{ cycleTitle }}</p>
    </section>
    <input
      v-if="!videoContainsFile"
      @click="addtoVideo(id)"
      type='button'
      value='Copy To'
      class='button is-primary'/>
    <input
      v-else="videoContainsFile"
      :disabled="videoContainsFile"
      type='button'
      value='Already Added'
      class='button is-warning'/>
  </li>
</template>

<script>
import store from '../store'
export default {
  name: 'VideoModalVideo',
  props: {
    id: {
      type: Number,
      required: true,
    },
    cycleID: {
      type: Number,
      required: true,
    },
    fileID: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    addtoVideo () {
      const { cycleID, id, fileID } = this
      store.dispatch('copyFile', {
        destCycleID: cycleID,
        destVideoID: id,
        fileToCopy: fileID,
      })
      .then(() => {
        this.$emit('close')
      })
    },
  },
  computed: {
    cycleTitle () {
      const cycle = store.state.cycles.find(x => x.id === this.id)
      return cycle != null ? cycle.title : null
    },
    videoContainsFile () {
      const vid = store.state.videos[this.id]
      if (vid.resources != null) {
        return vid.resources.filter(x => x.id === this.fileID).length > 0
      } else {
        // we know that there are no resources so the file can't possibly be in
        // the resources
        return false
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// VideoModalVideo.vue?3568afc6